export default __webpack_public_path__ + "static/media/woman.05242306.svg";